import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import AssignmentTurnedInOutlined from '@mui/icons-material/AssignmentTurnedInOutlined'
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import GoogleIcon from '../../../icon/GoogleIcon'
import { formatMoney, safePercent, extractActiveRoles } from '../../../helpers/utils'
import { formatLastActivity } from './reportMobileUserCardUtils'

const iconSize = { fontSize: 20 }

export function buildReportSummaryUserMobileCardSections(model) {
  const userName = model.user_name ?? '—'
  const visited = model.total_visited_clients_count ?? 0
  const attended = model.total_attended_clients_count ?? 0
  const visitasStr = `${visited}/${attended}`

  const posLine = extractActiveRoles(model.user_active_roles).includes('pos_task_activity')
    ? `${model.pos_task_activity_done_task_codes_count ?? 0}/${model.pos_task_activity_total_clients_count ?? 0}`
    : 'N/A'

  const summaryRows = [
    {
      label: 'Usuario',
      value: userName,
      valueTitle: userName
    },
    {
      label: 'Última actividad',
      value: formatLastActivity(model.last_visit),
      valueTitle: formatLastActivity(model.last_visit)
    },
    {
      label: 'Visitas realizadas',
      value: visitasStr,
      valueTitle: visitasStr
    }
  ]

  const pct = safePercent(model.total_effective_clients_count, model.total_attended_clients_count)

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: `${model.out_of_route_clients ?? 0}`,
      boldValue: true,
      valueTitle: `${model.out_of_route_clients ?? 0}`
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${pct}%`,
      boldValue: true,
      valueTitle: `${pct}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: `${model.geofence_effective_clients_count ?? 0}/${model.geofence_location_available_count ?? 0}`,
      boldValue: true
    },
    {
      icon: <AssignmentTurnedInOutlined sx={iconSize} />,
      label: 'Tareas en sitio',
      value: posLine,
      boldValue: true,
      valueTitle: posLine
    },
    {
      icon: <GoogleIcon name="replay" size={20} />,
      label: 'Total devoluciones',
      value: formatMoney(model.total_refund),
      boldValue: true,
      valueTitle: formatMoney(model.total_refund)
    },
    {
      icon: <LocalShippingOutlined sx={iconSize} />,
      label: 'Total entregas',
      value: formatMoney(model.total_delivery),
      boldValue: true,
      valueTitle: formatMoney(model.total_delivery)
    },
    {
      icon: <ShoppingCartOutlined sx={iconSize} />,
      label: 'Total pedidos',
      value: formatMoney(model.total_order),
      boldValue: true,
      valueTitle: formatMoney(model.total_order)
    }
  ]

  return { summaryRows, detailRows }
}
